import StandardAutocompleteIdsWithFallback from "@features/standardDesign/components/autocomplete/StandardAutocompleteIds";
import { useLingui } from "@lingui/react";
import { Box, FormControl, FormHelperText, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { AlertConfigurationForm } from "../../schemas/alertConfigurationSchema";

const DeviceSelectionStep = () => {
  const { _ } = useLingui();
  const { control, formState: { errors }, watch } = useFormContext<AlertConfigurationForm>();
  const deviceId = watch('deviceId');

  return (
    <div>
      <Box sx={{ mb: 2 }}>

      <Typography variant='h5'>
        Configuración de sus dispositivos
      </Typography>
      <Typography>
        Elige un dispositivo y configura una alerta para cualquiera de sus métricas disponibles.
      </Typography>
      </Box>

      <Controller
        control={control}
        name='deviceId'
        render={({ field, fieldState: { error } }) => (
          <Box>
            <StandardAutocompleteIdsWithFallback
              dataType='devices'
              value={deviceId}
              fullWidth
              label='Dispositivo'
              onChange={(_, value) => field.onChange(value)}
              helperText={error?.message}
              error={!!error}
            />
          </Box>
        )}
      />
    </div>
  );
};

export default DeviceSelectionStep;